import React, {useEffect, useMemo, useRef} from 'react';
import styled from "styled-components";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import { useTranslation } from 'react-i18next';
import { formatNumber } from "../../Format";
import merge from "lodash/merge";
import Chart from "../../charts/Chart";

const ChartContainer = styled.div`
  width: 200px;
  height: 200px;
  margin: -50px -5px;
  position: relative;
  border-radius: 50%;
  background-color: #eee;
  box-sizing: border-box;
  flex-shrink: 0;
  @media (max-width: 1000px) {
    width: 150px;
    height: 150px;
    margin: -30px -5px;
  }`

const GaugeLabel = styled.div`
  white-space: nowrap;
  position: absolute;
  text-align: center;
  font-size: 30px;
  transform: translate(-50%, -50%);
  left: 100px;
  top: 100px;
  @media (max-width: 1000px) {
    font-size: 20px;
    left: 75px;
    top: 75px;
  }
`

const GaugeTitle = styled.div`
  color: #888;
  text-transform: uppercase;
  margin-top: -3px;
  font-size: 12px;
  `
export default function PercentGaugeKpi ({value, title}) {
  const gaugeOptions = {
    chart: {
      type: 'pie',
      backgroundColor: "transparent"
    },
    credits: {
      enabled: false
    },
    legend: false,
    title: {
      text: ''
    },
    // tooltip: false,
    exporting: false,
    plotOptions: {
      pie: {
        innerSize: '90%',
        colors: [
          '#FF513C',
          '#CCCCCC'
        ],
        dataLabels: {
          enabled: false
        }
      }
    }
  }

  function dataOption(val) {
    return {...gaugeOptions, series: [{ data: [
          ['Location', val],
          ['no loc', 100-val]
        ] }]}
  }


  return (
    <ChartContainer>
      <Chart
        options={dataOption(value)}
        legendOptions={{show: false}}
      />
      <GaugeLabel>{formatNumber(value)} %
        <GaugeTitle>{title}</GaugeTitle>
      </GaugeLabel>
    </ChartContainer>
  )
}

